import { NavLink, useLocation } from "react-router-dom";
import { House, ListChecks, ShoppingBag, UsersThree } from "@phosphor-icons/react";

const items = [
  { to: "/", label: "Home", icon: House, testid: "nav-home" },
  { to: "/projects", label: "Projects", icon: ListChecks, testid: "nav-projects" },
  { to: "/shop", label: "Shop", icon: ShoppingBag, testid: "nav-shop" },
  { to: "/household", label: "Household", icon: UsersThree, testid: "nav-household" },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  const hidden = pathname.startsWith("/login") || pathname.startsWith("/invite/") || pathname.startsWith("/request-access");
  if (hidden) return null;

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-40 h-[84px] bg-chalk border-t-2 border-[#D5CEC4] pb-safe"
    >
      <div className="grid grid-cols-4 h-full max-w-md mx-auto">
        {items.map(({ to, label, icon: Icon, testid }) => {
          const active =
            to === "/" ? pathname === "/" : pathname.startsWith(to);
          return (
            <NavLink
              key={to}
              to={to}
              data-testid={testid}
              className="flex flex-col items-center justify-center gap-1 relative"
            >
              <Icon
                size={26}
                weight={active ? "fill" : "regular"}
                color={active ? "#E07A5F" : "#594A42"}
              />
              <span
                className={`text-[11px] font-semibold tracking-wide ${
                  active ? "text-masking" : "text-timber-700"
                }`}
              >
                {label}
              </span>
              {active && (
                <span className="absolute top-1 h-[3px] w-8 rounded-full bg-masking" />
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
